import Axios from "axios";
import {
    SET_MANUFACTURE_LIST,
    UNSET_MANUFACTURE_LIST,
  } from "@/store/mutation-types";
import { saveUpdateManufacture, getManufactureList, generateManufactureCode } from "@/store/api";
// initial state
const state = {
  getManufactureList: [],
};

const getters = {
  getManufactureList(state) {
    return state.getManufactureList;
  }
};

const mutations = {
  [SET_MANUFACTURE_LIST](state, data) {
    state.getManufactureList = data;
  },
  [UNSET_MANUFACTURE_LIST](state) {
    state.getManufactureList = [];
  },

};

const actions = {

  saveUpdateManufacture({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateManufacture, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getManufactureList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getManufactureList, data)
        .then(function (response) {
          commit('SET_MANUFACTURE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_MANUFACTURE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getGeneratedManufactureCode({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(generateManufactureCode)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default {
  state,
  getters,
  actions,
  mutations,
};
